<template>
    <AdaptersOverlayPanel
        :base-z-index="100001"
        :hover-usage="true"
        :listener-id="listenerId"
        :pt="{
            content: {class: 'p-0'},
            root: {class: 'menu_system_notifications__overlay'}
        }"
    >
        <div class="menu_system_notifications__content_container flex flex-column">
            <div class="flex flex-column">
                <template v-if="hasNew">
                    <div v-for="(item, index) in items" class="menu_system_notifications__item_container">
                        <div
                            class="menu_system_notifications__item_content"
                            :class="{'link': !!item.link && item.link.length > 0}"
                            @click="onClickLink(item, index)"
                        >
                            <span class="menu_system_notifications__item_title">
                                {{ item.title }}
                            </span>
                            <span class="menu_system_notifications__item_date">
                                {{ formatDateTime(item.startedAt) }}
                            </span>
                        </div>
                        <i
                            v-if="isUserAuthenticated"
                            class="pi pi-times menu_system_notifications__item_close"
                            @click="$emit('onMarkSingle', {id: item.id, index: index})"
                        ></i>
                    </div>
                </template>
                <span v-else class="menu_system_notifications__empty p-3">
                    {{ $t('lang.system_notifications.empty_new_messages') }}
                </span>
            </div>
            <Divider class="p-0 m-0" />
            <div class="menu_system_notifications__footer">
                <span v-if="hasNew && isUserAuthenticated" @click="$emit('onMarkAll')">
                    {{ $t('lang.system_notifications.mark_all') }}
                </span>
                <a href="/ru/system-notifications">
                    {{ $t('lang.system_notifications.show_all') }}
                </a>
            </div>
        </div>
    </AdaptersOverlayPanel>
</template>

<script>
import AdaptersOverlayPanel from "../../adapters/OverlayPanel.vue";
import {Listeners} from "../../../constants/listeners";
import moment from "moment";
import {get} from "lodash";
import Divider from "primevue/divider";

export default {
    name: "MenuSystemNotifications",
    emits: ['onMarkSingle', 'onMarkAll'],
    props: {
        count: {
            type: Number,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            listenerId: Listeners.TOP_MENU_SYSTEM_NOTIFICATIONS_HOVER,
        };
    },
    computed: {
        hasNew() {
            return this.count > 0;
        },
        isUserAuthenticated() {
            return this.$store.getters.IS_USER_AUTHENTICATED;
        }
    },
    methods: {
        onClickLink(item, index) {
            if (!item.link || item.link.length === 0) {
                return;
            }

            window.open(item.link, '_blank');
            if (this.isUserAuthenticated) {
                this.$emit('onMarkSingle', {id: item.id, index: index});
            }
        },
        formatDateTime(value) {
            return moment(get(value, 'date')).format('DD.MM.YY HH:mm');
        },
    },
    components: {
        AdaptersOverlayPanel,
        Divider,
    },
}
</script>

<style scoped>
.menu_system_notifications__content_container {
    width: 280px;
    overflow: hidden;
    border-radius: 10px;
}
.menu_system_notifications__item_container:hover {
    transition: all .3s;
    background-color: #EBF1F6;
}
.menu_system_notifications__item_container {
    display: flex;
    gap: 16px;
    padding: 16px;
}
.menu_system_notifications__item_title {
    color: #232D35;
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
    cursor: default;
    transition: all .3s;
}
.menu_system_notifications__item_content.link .menu_system_notifications__item_title {
    transition: all .3s;
    cursor: pointer;
}
.menu_system_notifications__item_content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.menu_system_notifications__item_content.link:hover .menu_system_notifications__item_title {
    color: #0B69F5;
    text-decoration-color: #0B69F5;
    /*add those for opera and mozilla support*/
    -webkit-text-decoration-color: #0B69F5;
    -moz-text-decoration-color: #0B69F5;
    text-decoration: underline;
}
.menu_system_notifications__item_date {
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: #A4B1BE;
}
.menu_system_notifications__item_close {
    opacity: 0;
    transition: all .3s;
    cursor: pointer;
}
.menu_system_notifications__item_container:hover .menu_system_notifications__item_close {
    opacity: 1;
}
.menu_system_notifications__empty {
    font-size: 13px;
}
.menu_system_notifications__footer {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: center;
}
.menu_system_notifications__footer span {
    font-size: 13px;
    line-height: 21px;
    padding: 8px 0;
    margin-bottom: 4px;
    font-weight: 400;
    color: #000000;
    cursor: pointer;
}
.menu_system_notifications__footer a {
    font-size: 13px;
    line-height: 21px;
    background-color: #70B319;
    padding: 8px 0;
    border-radius: 5px;
    color: #fff;
    text-decoration: none;
}
</style>

<style>
.menu_system_notifications__overlay:after {
    content: none;
}
</style>
